import { createReducer, on } from "@ngrx/store";
import { billActions } from "../bill.actions";

export const initialState: string = '';

export const billsGetCsvReducer = createReducer(
    initialState,
    on(billActions.getCSVSuccess, (state, {payload}) => payload),
    on(billActions.clearCSV, (state) => initialState)
)